import { render } from "./ContentHeader.vue?vue&type=template&id=6fee5ec2&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"

import "./ContentHeader.vue?vue&type=style&index=0&id=6fee5ec2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fee5ec2"],['__file',"src/components/consultant/ContentHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fee5ec2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fee5ec2', __exports__)) {
    api.reload('6fee5ec2', __exports__)
  }
  
  module.hot.accept("./ContentHeader.vue?vue&type=template&id=6fee5ec2&scoped=true", () => {
    api.rerender('6fee5ec2', render)
  })

}


export default __exports__